const urlJoin = require('url-join');
const { siteUrl } = require('./index');

exports.googleMapAddressRoute = 'maps.google.com/maps?daddr=台南市崇善路205巷3號&amp;ll=';
exports.googleMapAddressRouteWithProtocoal = 'https://maps.google.com/maps?daddr=台南市崇善路205巷3號&amp;ll=';
exports.telPhoneUrl = 'tel:88662684508';
exports.ogUrl = urlJoin(siteUrl, '/img/og-1200.png');
exports.dittoSymbol = '$';
